import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

class BookingPhase extends Component {

  render() {
    const { id, title, visible, available, t } = this.props;
    const visibleClasses = visible ? 'in' : '';
    const availableClasses = available ? '' : 'disabled';

    return (
      <footer id={id} className={`booking-phase collapse ${visibleClasses} ${availableClasses}`}>
        <h2 
          tabIndex={0}
          id={`${id}-title`}
          aria-label={t('common:ariaLabels.footerLabel')}
          className="booking-phase-title"
        >
          {title}
        </h2>
        <hr />
        <div className="booking-phase-content">
          {this.props.children}
        </div>
      </footer>
    );
  }
}

BookingPhase.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  visible: PropTypes.bool,
  available: PropTypes.bool,
  children: PropTypes.node,
  t: PropTypes.func.isRequired
};

BookingPhase.defaultProps = {
  visible: true,
  available: true,
  children: null
};

export default translate(['common', 'booking'])(BookingPhase);



// WEBPACK FOOTER //
// ./src/components/BookingPhase/BookingPhase.jsx